<template>
  <div class="content container-fluid">
    <div class="text-center offset-md-3 col-md-6" :class="topClasses">
      <div class="d-inline-flex mb-2">
        <cld-image public-id="sandkastenliga/favicon" height="36px" class="align-self-center img-fluid"/>
        <div class="d-inline-flex align-self-center font-weight-bold ps-2" style="font-size: xx-large">
          <slot name="heading"/>
        </div>
      </div>
      <slot name="main"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    topClasses: String
  }
}
</script>
